import React from 'react';

type FormErrorProps = {
  error: string | undefined;
};

const Error = ({ error }: FormErrorProps) => {
  if (!error) {
    return null;
  }
  return <p className="text-xs text-red-500">{error}</p>;
};

export default Error;
